webpackJsonp([5],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
__webpack_require__("wPPq");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "40hC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-table"},[_c('div',{staticClass:"responsive"},[(_vm.paginate && !_vm.tableInside && _vm.showTopNavigation)?_c('div',{staticClass:"table-header clearfix"},[_c('div',{staticClass:"pagination-controls controls-top pull-left"},[_c('a',{staticClass:"page-btn",attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.previousPage($event)}}},[_c('span',{staticClass:"chevron left"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.prevText))])]),_vm._v(" "),_c('div',{class:{'info-mobile': _vm.showPageNumberForMobile, 'info': !_vm.showPageNumberForMobile}},[_vm._v(_vm._s(_vm.paginatedInfo))]),_vm._v(" "),_c('a',{staticClass:"page-btn",attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.nextPage($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextText))]),_vm._v(" "),_c('span',{staticClass:"chevron right"})])]),_vm._v(" "),_c('div',{staticClass:"datatable-length pull-left"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.rowsPerPageText))]),_vm._v(" "),(_vm.perPage)?_c('span',{staticClass:"perpage-count"},[_vm._v(_vm._s(_vm.perPage))]):_vm._e(),_vm._v(" "),(!_vm.perPage)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPerPage),expression:"currentPerPage"}],staticClass:"browser-default",attrs:{"disabled":this.processedRows.length <= 10},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPerPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onTableLength]}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("All")])]):_vm._e()])]),_vm._v(" "),(_vm.showHeadText)?_c('div',{staticClass:"pull-right"},[_c('span',{staticClass:"tfoot-text"},[_vm._v(_vm._s(_vm.headLabel)+" "+_vm._s(_vm.headValue))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"table-header clearfix"},[_c('h2',{staticClass:"table-title pull-left"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"actions pull-right"})]):_vm._e(),_vm._v(" "),_c('table',{ref:"table",class:_vm.styleClass},[_c('thead',[(_vm.globalSearch && _vm.externalSearchQuery == null)?_c('tr',[_c('td',{attrs:{"colspan":_vm.lineNumbers ? _vm.columns.length + 1: _vm.columns.length}},[_c('div',{staticClass:"global-search"},[_vm._m(0,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.globalSearchTerm),expression:"globalSearchTerm"}],staticClass:"form-control global-search-input",attrs:{"type":"text","placeholder":_vm.globalSearchPlaceholder},domProps:{"value":(_vm.globalSearchTerm)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchTable()},"input":function($event){if($event.target.composing){ return; }_vm.globalSearchTerm=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('tr',[(_vm.lineNumbers)?_c('th',{staticClass:"line-numbers"}):_vm._e(),_vm._v(" "),_vm._t("custom-columns",_vm._l((_vm.columns),function(column,index){return (!column.hidden)?_c('th',{class:_vm.columnHeaderClass(column, index),style:({width: column.width ? column.width : 'auto'}),on:{"click":function($event){_vm.sort(index)}}},[_c('span',[_vm._v(_vm._s(column.label))])]):_vm._e()}),{columns:_vm.columns,sort:_vm.sort,columnHeaderClass:_vm.columnHeaderClass}),_vm._v(" "),_vm._t("thead-tr")],2),_vm._v(" "),(_vm.hasFilterRow)?_c('tr',[(_vm.lineNumbers)?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return _c('th',[(column.filterable)?_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":'Filter ' + column.label},domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}}):_vm._e()])})],2):_vm._e()]),_vm._v(" "),_c('tbody',[_vm._l((_vm.paginated),function(row,index){return [_c('tr',{class:{ 'clickable' : _vm.onClick, 'details-head' : _vm.tableInside },on:{"click":function($event){_vm.click(row, index)}}},[_vm._t("table-row",_vm._l((_vm.columns),function(column,i){return (!column.hidden)?_c('td',{class:_vm.getDataStyle(i, 'td')},[(!column.html)?_c('span',[_vm._v(_vm._s(_vm.collectFormatted(row, column)))]):_vm._e(),_vm._v(" "),(column.html)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.collect(row, column.field))}}):_vm._e()]):_vm._e()}),{row:row,index:index})],2),(_vm.tableInside)?_c('tr',{staticClass:"details-row"},[_vm._t("table-in-row",null,{index:index,row:row,currentPerPage:_vm.currentPerPage,currentPage:_vm.currentPage})],2):_vm._e()]}),_vm._v(" "),_vm._t("table-under-banner")],2)])]),_vm._v(" "),(_vm.paginate)?_c('div',{staticClass:"table-footer clearfix"},[_c('div',{staticClass:"pagination-controls controls-bottom pull-left"},[_c('a',{staticClass:"page-btn",attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.previousPage($event)}}},[_c('span',{staticClass:"chevron left"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.prevText))])]),_vm._v(" "),_c('div',{class:{'info-mobile': _vm.showPageNumberForMobile, 'info': !_vm.showPageNumberForMobile}},[_vm._v(_vm._s(_vm.paginatedInfo))]),_vm._v(" "),_c('a',{staticClass:"page-btn",attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.nextPage($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextText))]),_vm._v(" "),_c('span',{staticClass:"chevron right"})])]),_vm._v(" "),_c('div',{staticClass:"datatable-length pull-left"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.rowsPerPageText))]),_vm._v(" "),(_vm.perPage)?_c('span',{staticClass:"perpage-count"},[_vm._v(_vm._s(_vm.perPage))]):_vm._e(),_vm._v(" "),(!_vm.perPage)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPerPage),expression:"currentPerPage"}],staticClass:"browser-default",attrs:{"disabled":this.processedRows.length <= 10},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPerPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onTableLength]}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v("All")])]):_vm._e()])]),_vm._v(" "),(_vm.showFootText)?_c('div',{staticClass:"pull-right"},[_c('span',{staticClass:"tfoot-text"},[_vm._v(_vm._s(_vm.footLabel)+" "+_vm._s(_vm.footValue))])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"global-search-icon"},[_c('img',{attrs:{"src":__webpack_require__("oNHd"),"alt":"Search Icon"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4sUD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.svg";

/***/ }),

/***/ "5SNe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-eot.eot";

/***/ }),

/***/ "6juP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "85ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B+/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ServiceContainer__ = __webpack_require__("tpCU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common__);



function configureRouter(router) {
  router.beforeEach(function (to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_0__services_ServiceContainer__["b" /* authService */].isLoggedIn()) {
      var currentUrl = document.URL;
      window.location.href = __WEBPACK_IMPORTED_MODULE_1_my_account_common__["commonCfg"].loginUrl + encodeURIComponent(currentUrl);
    } else {
      next();
    }
  });
}

/***/ }),

/***/ "KyWb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgreementsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__ = __webpack_require__("d45q");



var AgreementsService = function () {
  function AgreementsService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AgreementsService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AgreementsService, [{
    key: 'getAgreements',
    value: function getAgreements(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].agreements, config, { useCache: true });
    }
  }, {
    key: 'agreementsPDFDownload',
    value: function agreementsPDFDownload(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].agreementsPDFDownload, config);
    }
  }, {
    key: 'sendLexmarkRequest',
    value: function sendLexmarkRequest(config) {
      return this.axios.post(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].sendLexmarkRequest, config);
    }
  }]);

  return AgreementsService;
}();

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516b51f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("xUcz");
function injectStyle (ssrContext) {
  __webpack_require__("cNwW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516b51f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_my_account_table__ = __webpack_require__("ZOlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_routerConfig__ = __webpack_require__("B+/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_validation_messages__ = __webpack_require__("lIB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_toasted__);
















__webpack_require__("85ql");

var config = {
  locale: 'en',
  dictionary: __WEBPACK_IMPORTED_MODULE_9__assets_validation_messages__["a" /* default */],
  events: 'input'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* default */], config);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_my_account_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_toasted___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});
Object(__WEBPACK_IMPORTED_MODULE_6__router_routerConfig__["a" /* configureRouter */])(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

/***/ }),

/***/ "RPLo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CVService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__ = __webpack_require__("d45q");



var CVService = function () {
  function CVService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CVService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CVService, [{
    key: 'getCVHistory',
    value: function getCVHistory(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].cvHistory, config, { useCache: true });
    }
  }, {
    key: 'clubVisitsPDFDownload',
    value: function clubVisitsPDFDownload(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].clubVisitPDFDownload, config);
    }
  }]);

  return CVService;
}();

/***/ }),

/***/ "RqFH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-woff2.woff2";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");



var Agreements = function Agreements() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Swgo"));
};
var ClubVisits = function ClubVisits() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "EJaC"));
};
var ClubVisitsMobile = function ClubVisitsMobile() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "8o+v"));
};
var PersonalTraining = function PersonalTraining() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "aoFo"));
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/agreements',
    name: 'Agreements',
    component: Agreements
  }, {
    path: '/club-visits',
    name: 'ClubVisits',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (window.innerWidth < 768) {
          ClubVisitsMobile().then(function (response) {
            resolve(response);
          });
        } else {
          ClubVisits().then(function (response) {
            resolve(response);
          });
        }
      });
    }
  }, {
    path: '/personal-training',
    name: 'PersonalTraining',
    component: PersonalTraining
  }, {
    path: '*',
    redirect: '/personal-training'
  }]
}));

/***/ }),

/***/ "aY/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PTSessionsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__ = __webpack_require__("d45q");



var PTSessionsService = function () {
  function PTSessionsService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PTSessionsService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PTSessionsService, [{
    key: 'getPTSessionsHistory',
    value: function getPTSessionsHistory() {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].ptSessionsHistory, { useCache: true });
    }
  }, {
    key: 'validateDateRange',
    value: function validateDateRange(fromDate, toDate) {
      console.log(fromDate);
      console.log(toDate);
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].ptSessionsHistory, {
        params: {
          fromDate: fromDate,
          toDate: toDate
        }
      });
    }
  }]);

  return PTSessionsService;
}();

/***/ }),

/***/ "cNwW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d45q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common__);



var Config = function Config() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Config);

  this.ptSessionsHistory = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-member-current-agreements-process/getPTSessionHistory';
  this.clubVisitPDFDownload = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-print-club-visits-process/PrintClubVisits';
  this.cvHistory = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-get-club-visits-process/ClubVisits';
  this.agreements = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-get-agreements-process/GetAgreements';
  this.personalTraining = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-member-current-agreements-process/getPTSessionHistory';
  this.agreementsPDFDownload = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-request-agreement-pdf-process/RequestAgreementPdf';
  this.sendLexmarkRequest = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-request-agreement-copy-process/RequestAgreementCopy';
};

var cfg = new Config();
/* harmony default export */ __webpack_exports__["a"] = (cfg);

/***/ }),

/***/ "ezWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonalTrainingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__ = __webpack_require__("d45q");



var PersonalTrainingService = function () {
  function PersonalTrainingService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PersonalTrainingService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PersonalTrainingService, [{
    key: 'getPersonalTraining',
    value: function getPersonalTraining(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].personalTraining, config, { useCache: true });
    }
  }]);

  return PersonalTrainingService;
}();

/***/ }),

/***/ "lIB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dictionary = {
  en: {
    messages: {
      required: function required() {
        return 'This is a required field.';
      },
      email: function email() {
        return 'The email field must be a valid email.';
      }
    },
    custom: {}
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dictionary);

/***/ }),

/***/ "o43L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("rGED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b6744c24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("40hC");
function injectStyle (ssrContext) {
  __webpack_require__("6juP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6744c24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b6744c24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oNHd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/search_icon.png";

/***/ }),

/***/ "rGED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_parse__ = __webpack_require__("xA5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format__ = __webpack_require__("Eoz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_format__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-good-table',
  props: {
    styleClass: { default: 'table table-bordered' },
    title: '',
    columns: {},
    rows: {},
    onClick: {},
    perPage: {},
    sortable: { default: true },
    paginate: { default: false },
    lineNumbers: { default: false },
    defaultSortBy: { default: null },
    tableInside: { default: false },
    showTopNavigation: { default: false },

    globalSearch: { default: false },
    searchTrigger: { default: null },
    externalSearchQuery: { default: null },

    globalSearchPlaceholder: { default: 'Search Table' },
    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },

    showHeadText: { default: false },
    headLabel: { default: '' },
    headValue: { default: '' },

    showFootText: { default: false },
    footLabel: { default: '' },
    footValue: { default: '' },
    showPageNumberForMobile: { default: false }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10,
      sortColumn: -1,
      sortType: 'asc',
      globalSearchTerm: '',
      columnFilters: {},
      filteredRows: [],
      timer: null,
      forceSearch: false,
      sortChanged: false
    };
  },

  methods: {
    nextPage: function nextPage() {
      if (this.currentPerPage == -1) return;
      if (this.processedRows.length > this.currentPerPage * this.currentPage) ++this.currentPage;
    },
    previousPage: function previousPage() {

      if (this.currentPage > 1) --this.currentPage;
    },
    onTableLength: function onTableLength(e) {
      this.currentPerPage = e.target.value;
    },
    sort: function sort(index) {
      if (!this.sortable) return;
      if (this.sortColumn === index) {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortType = 'asc';
        this.sortColumn = index;
      }
      this.sortChanged = true;
    },
    click: function click(row, index) {
      if (this.onClick) this.onClick(row, index);
    },
    searchTable: function searchTable() {
      if (this.searchTrigger == 'enter') {
        this.forceSearch = true;
        this.sortChanged = true;
      }
    },
    collect: function collect(obj, field) {
      function dig(obj, selector) {
        var result = obj;
        var splitter = selector.split('.');
        for (var i = 0; i < splitter.length; i++) {
          if (typeof result === 'undefined') return undefined;else result = result[splitter[i]];
        }return result;
      }

      if (typeof field === 'function') return field(obj);else if (typeof field === 'string') return dig(obj, field);else return undefined;
    },
    collectFormatted: function collectFormatted(obj, column) {
      function formatDecimal(v) {
        return parseFloat(Math.round(v * 100) / 100).toFixed(2);
      }

      function formatPercent(v) {
        return parseFloat(v * 100).toFixed(2) + '%';
      }

      function formatDate(v) {
        return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_parse___default()(v, column.inputFormat), column.outputFormat);
      }

      var value = this.collect(obj, column.field);

      if (!value) return '';

      switch (column.type) {
        case 'decimal':
          return formatDecimal(value);
        case 'percentage':
          return formatPercent(value);
        case 'date':
          return formatDate(value);
        default:
          return value;
      }
    },
    columnHeaderClass: function columnHeaderClass(column, index) {
      var classString = '';
      if (this.sortable) {
        classString += 'sorting ';
      }
      if (index === this.sortColumn) {
        if (this.sortType === 'desc') {
          classString += 'sorting-desc ';
        } else {
          classString += 'sorting-asc ';
        }
      }
      classString += this.getDataStyle(index, 'th');
      return classString;
    },
    getDataStyle: function getDataStyle(index, type) {
      var classString = '';
      if (typeof type !== 'undefined' && this.columns[index].hasOwnProperty(type + 'Class')) {
        classString = this.columns[index][type + 'Class'];
      } else {
        switch (this.columns[index].type) {
          case 'number':
          case 'percentage':
          case 'decimal':
          case 'date':
            classString = 'right-align ';
            break;
          default:
            classString = 'left-align ';
            break;
        }
      }
      return classString;
    },
    updateFilters: function updateFilters(column, value) {
      var _this = this;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$set(_this.columnFilters, column.field, value);
      }, 400);
    },
    filterRows: function filterRows() {
      var _this2 = this;

      var computedRows = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.rows));
      if (this.hasFilterRow) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var col = _step.value;

            if (col.filterable && this.columnFilters[col.field]) {
              computedRows = computedRows.filter(function (row) {

                if (col.filter) {
                  return col.filter(_this2.collect(row, col.field), _this2.columnFilters[col.field]);
                }

                switch (col.type) {
                  case 'number':
                  case 'percentage':
                  case 'decimal':
                    return _this2.collect(row, col.field) == _this2.columnFilters[col.field];
                  default:
                    return _this2.collect(row, col.field).toLowerCase().startsWith(_this2.columnFilters[col.field].toLowerCase());
                }
              });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.filteredRows = computedRows;
    },
    getCurrentIndex: function getCurrentIndex(index) {
      return (this.currentPage - 1) * this.currentPerPage + index + 1;
    },
    showPageNumberForMobileClass: function showPageNumberForMobileClass() {
      var className = 'info';
      if (this.showPageNumberForMobile) {
        console.log('set pagination for mobile');
        className = 'info-mobile';
      }
      return className;
    }
  },

  watch: {
    columnFilters: {
      handler: function handler(newObj) {
        this.filterRows();
      },
      deep: true
    },
    rows: {
      handler: function handler(newObj) {
        this.filterRows();
      },
      deep: true
    },
    perPage: function perPage() {
      if (this.perPage) {
        this.currentPerPage = this.perPage;
      } else {
        this.currentPerPage = 10;
      }
    }
  },

  computed: {
    searchTerm: function searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },
    globalSearchAllowed: function globalSearchAllowed() {
      if (this.globalSearch && !!this.globalSearchTerm && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.externalSearchQuery != null && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.forceSearch) {
        this.forceSearch = false;
        return true;
      }

      return false;
    },
    hasFilterRow: function hasFilterRow() {
      if (!this.globalSearch) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var col = _step2.value;

            if (col.filterable) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return false;
    },
    processedRows: function processedRows() {
      var _this3 = this;

      var computedRows = this.filteredRows;

      if (this.globalSearchAllowed) {
        var filteredRows = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.rows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var row = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.columns), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var col = _step4.value;

                if (String(this.collectFormatted(row, col)).toLowerCase().includes(this.searchTerm.toLowerCase())) {
                  filteredRows.push(row);
                  break;
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        computedRows = filteredRows;
      }

      if (this.sortable !== false && this.sortColumn !== -1 && (this.searchTrigger != 'enter' || this.sortChanged)) {

        this.sortChanged = false;

        computedRows = computedRows.sort(function (x, y) {
          if (!_this3.columns[_this3.sortColumn]) return 0;

          var cook = function cook(x) {
            x = _this3.collect(x, _this3.columns[_this3.sortColumn].field);

            if (typeof x === 'string') {
              x = x.toLowerCase();
              if (_this3.columns[_this3.sortColumn].type == 'number') x = x.indexOf('.') >= 0 ? parseFloat(x) : parseInt(x);
            }

            if (_this3.columns[_this3.sortColumn].type === 'date') {
              x = __WEBPACK_IMPORTED_MODULE_3_date_fns_parse___default()(x + '', _this3.columns[_this3.sortColumn].inputFormat);
            }

            return x;
          };

          x = cook(x);
          y = cook(y);

          return (x < y ? -1 : x > y ? 1 : 0) * (_this3.sortType === 'desc' ? -1 : 1);
        });
      }

      if (this.searchTrigger == 'enter') {
        this.filteredRows = computedRows;
      }

      return computedRows;
    },
    paginated: function paginated() {
      var paginatedRows = this.processedRows;

      if (this.paginate) {
        var pageStart = (this.currentPage - 1) * this.currentPerPage;

        if (pageStart >= this.processedRows.length || this.currentPerPage == -1) {
          this.currentPage = 1;
          pageStart = 0;
        }

        var pageEnd = paginatedRows.length + 1;

        if (this.currentPerPage != -1) {
          pageEnd = this.currentPage * this.currentPerPage;
        }

        paginatedRows = paginatedRows.slice(pageStart, pageEnd);
      }
      return paginatedRows;
    },
    paginatedInfo: function paginatedInfo() {
      var infoStr = 'Page ';
      infoStr += this.currentPage;
      infoStr += ' of ';
      infoStr += Math.ceil(this.processedRows.length / this.currentPerPage);
      if (this.currentPerPage == -1 || this.processedRows.length === 0) {
        return 'Page 1 ' + this.ofText + ' 1';
      }
      return infoStr;
    }
  },

  mounted: function mounted() {
    this.filteredRows = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.rows));

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.filteredRows.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var _ref = _step5.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var index = _ref2[0];
        var row = _ref2[1];

        row.originalIndex = index;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }

    if (this.defaultSortBy) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.columns.entries()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref3 = _step6.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var _index = _ref4[0];
          var col = _ref4[1];

          if (col.field === this.defaultSortBy.field) {
            this.sortColumn = _index;
            this.sortType = this.defaultSortBy.type || 'asc';
            this.sortChanged = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "sPdF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-woff.woff";

/***/ }),

/***/ "tpCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axios */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authService; });
/* unused harmony export sessionCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ptSessionsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cvService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return agreementsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return personalTrainingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PTSessionsService__ = __webpack_require__("aY/1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AgreementsService__ = __webpack_require__("KyWb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonalTrainingService__ = __webpack_require__("ezWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CVService__ = __webpack_require__("RPLo");






var authService = new __WEBPACK_IMPORTED_MODULE_0_my_account_common__["AuthService"]();
var sessionCache = new __WEBPACK_IMPORTED_MODULE_0_my_account_common__["SessionCache"](authService, { key: 'my-pt' });
var axiosCache = Object(__WEBPACK_IMPORTED_MODULE_0_my_account_common__["cachiosConfigure"])(authService, { ttl: 5, sessionCache: sessionCache }, __WEBPACK_IMPORTED_MODULE_0_my_account_common__["cachiosFactory"]);
var ptSessionsService = new __WEBPACK_IMPORTED_MODULE_1__PTSessionsService__["a" /* PTSessionsService */](axiosCache);
var cvService = new __WEBPACK_IMPORTED_MODULE_4__CVService__["a" /* CVService */](axiosCache);
var agreementsService = new __WEBPACK_IMPORTED_MODULE_2__AgreementsService__["a" /* AgreementsService */](axiosCache);
var personalTrainingService = new __WEBPACK_IMPORTED_MODULE_3__PersonalTrainingService__["a" /* PersonalTrainingService */](axiosCache);



/***/ }),

/***/ "uk6X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-ttf.ttf";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TitleContainer: __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__["TitleContainer"],
    NavBar: __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__["NavBar"]
  },
  methods: {},
  data: function data() {
    return {
      navBarTabs: [{ name: 'Agreements', route: 'Agreements' }, { name: 'Personal Training', route: 'PersonalTraining' }, { name: 'Club Visits', route: 'ClubVisits' }]
    };
  },

  name: 'app'
});

/***/ }),

/***/ "xUcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","tabindex":"-1"}},[_c('title-container',{attrs:{"title":'My Membership'}}),_vm._v(" "),_c('nav-bar',{attrs:{"tabs":_vm.navBarTabs}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.js